import {
  SET_EXPIRING_TICKETS,
  DISMISS_TICKET_TOAST,
  SHOW_TICKET_MODAL,
  HIDE_TICKET_MODAL
} from "../actions/expiryActions";

const initialState = {
  expiringTickets: [],
  showToast: false,
  showModal: false
};

export default function expiryReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EXPIRING_TICKETS: {
      const { tickets, showToast } = action.payload;
      return {
        ...state,
        expiringTickets: tickets,
        // Keep an already-visible toast open; otherwise follow the policy
        showToast: tickets.length > 0 && (state.showToast || showToast)
      };
    }

    case DISMISS_TICKET_TOAST:
      return {
        ...state,
        showToast: false
      };

    case SHOW_TICKET_MODAL:
      return {
        ...state,
        showModal: true
      };

    case HIDE_TICKET_MODAL:
      return {
        ...state,
        showModal: false
      };

    default:
      return state;
  }
}
